const getSelectedNameSlot = (formValues, ownerNames) =>
  formValues.customOwnerName
    ? "other"
    : ownerNames.findIndex(name => name === formValues.predefinedOwnerName) + 1;

export default getSelectedNameSlot;
